import React from 'react'
import { Link } from 'react-router-dom';

import videoBg from '../assets/techno.mp4'
import logo from '../assets/Page1/SecuLogo.png';
import bar from '../assets/Page1/SecuBar.png';
import soon from '../assets/Page1/SecuSoon.png';


import Carousel from './Carousel';
import btn1 from '../assets/Page1/SecuHome.png';
import btn2 from '../assets/Page1/SecuDown.png';
import btn3 from '../assets/Page1/SecuUp.png';
import btn4 from '../assets/Page1/Secusteam.png';
import btn5 from '../assets/Page1/SecuCred.png';


const Main = () => {
    return (
        <div className='main'>
            <div className='overlay'></div>
            <video src = {videoBg} autoPlay loop muted />

            <div className="nav-bar">
                <img src={bar} alt="Navigation Bar" className="bar" />

                <div className="nav-buttons">
                    <img src={btn1} alt="Option 1" className="nav-btn" />
                    <img src={btn2} alt="Option 2" className="nav-btn" />

                    <Link to="/updates">
                        <img src={btn3} alt="Updates" className="nav-btn" />
                    </Link>
                    
                    <img src={btn4} alt="Option 4" className="nav-btn" />
                    <img src={btn5} alt="Option 5" className="nav-btn" />
                </div>
            </div>

            <div className='content'>
                <img src={logo} alt="Logo" className="logo" />
                <img src={soon} alt="Soon" className="soon" />
            </div>
             <Carousel />
        </div>
    );
}

export default Main